import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormControl, FormGroup , Validators} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  template: `
  <style>
  .mat-form-field--inline {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .mat-form-field--inline .mat-form-field {
        display: inline-block;
        width: 100%;
        vertical-align: middle;
    }

    .mat-form-field--inline .mat-form-field:nth-child(1) {
        margin-right: 10px;
    }
    
    @media (max-width: 767px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 1200px) {
      #selectLine{  
        width: 145%;
      } 
    }
      
    @media (min-width: 768px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 992px) {
      #selectLine{  
        width: 145%;
      } 
    }

    .example-full-width {
      
    }
  </style>
  <nb-card status="success"  [style.height.px]="630" [style.overflow]="'auto'">
  <nb-card-header>Add Educational Details</nb-card-header>
  <nb-card-body> 
    <span *ngIf="instructionValidation===false" style="color:red;">Please add medium of instruction which is below subjects.</span>
    <form [formGroup]="edu_form"  class="step-container">
      <div class="row">
        <div class="col-md-2">Course Name : </div>
        <div class="col-md-2"> 
          <!--<input  ngModel="{{edu_data?.CourseName}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.courseNameCtrl.invalid && (edu_form.controls.courseNameCtrl.dirty || edu_form.controls.courseNameCtrl.touched)}" formControlName="courseNameCtrl" placeholder="" id="" class="form-control">-->
          <mat-form-field id="selectLine" >
            <mat-select ngModel="{{course_name}}" name="coursename" formControlName="courseNameCtrl" disabled>
                <mat-option value="{{course.CourseShortForm}}" *ngFor="let course of course_data">{{course.CourseName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span *ngIf="courseValidation===false" style="color:red;">Please select College Year.</span>  
        </div>
        
      </div>
      <div class="row">
        <div class="col-md-2">College Year : </div>
        <div class="col-md-2">
          <mat-form-field id="selectLine" >
            <mat-select ngModel="{{college_year}}" name="collegeYear" formControlName="collegeYearCtrl" disabled>
                <mat-option *ngIf="edu_level == 'Course' || edu_level == 'Degree' || edu_level == 'Master' || edu_level == 'Bachelor'" value="First">First</mat-option>
                <mat-option *ngIf="edu_level == 'Course' || edu_level == 'Degree' || edu_level == 'Master' || edu_level == 'Bachelor'"value="Second">Second</mat-option>
                <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Bachelor'" value="Third">Third</mat-option>
                <!-- <mat-option value="Fourth">Fourth</mat-option> -->
            </mat-select>
          </mat-form-field>
          <span *ngIf="collegeYearValidation===false" style="color:red;">Please select College Year.</span> 
        </div>

        <div class="col-md-2"  style="padding-left: 9%;">Class Obtained : </div>
        <div class="col-md-2"  style="padding-left: 5%;">
            <mat-form-field id="selectLine" >
                <mat-select ngModel="{{edu_data?.overall_class}}" name="overall_class" formControlName="overallclassCtrl">
                    <mat-option value="First">First</mat-option>
                    <mat-option value="Second">Second</mat-option>
                    <mat-option value="Third">Third</mat-option>
                    <mat-option value="Pass">Pass</mat-option>
                    <mat-option value="Passes">Passes</mat-option>
                    <mat-option value="Distinction">Distinction</mat-option>
                </mat-select>
            </mat-form-field>
            <span *ngIf="classValidation===false" style="color:red;">Please select class</span> 
        </div>
    </div>
    
    <div class="row">
        <div class="col-md-2">Month : </div>
        <div class="col-md-2">
          <mat-form-field id="selectLine" >
            <mat-select  ngModel="{{edu_data?.Month}}" name="month" formControlName="monthCtrl">
                <mat-option value="January">January</mat-option>
                <mat-option value="February">February</mat-option>
                <mat-option value="March">March</mat-option>
                <mat-option value="April">April</mat-option>
                <mat-option value="May">May</mat-option>
                <mat-option value="June">June</mat-option>
                <mat-option value="July">July</mat-option>
                <mat-option value="August">August</mat-option>
                <mat-option value="September">September</mat-option>
                <mat-option value="October">October</mat-option>
                <mat-option value="November">November</mat-option>
                <mat-option value="December">December</mat-option>
            </mat-select>
          </mat-form-field>
          <span *ngIf="monthValidation===false" style="color:red;">Please select month</span> 
        </div>
        <div class="col-md-2" style="padding-left: 9%;">Year : </div>
        <div class="col-md-2" style="padding-left: 5%;">
            <mat-form-field id="selectLine" >
            <mat-select ngModel="{{enrollment_year}}" name="year" (valueChange)="changeValue($event)" formControlName="yearCtrl">
               <mat-option value="{{years}}" *ngFor="let years of enrollYear">{{years}}</mat-option>
                </mat-select>
            </mat-form-field>
            <span *ngIf="yearValidation===false" style="color:red;">Please select year.</span> 
        </div>
    </div>
   <!-- <div class="row">
    <div class="col-md-2" *ngIf="admin_show == 'true'"  >Start Month : </div>
    <div class="col-md-2" *ngIf="admin_show == 'true'">
      <mat-form-field id="selectLine" >
        <mat-select  ngModel="{{edu_data?.endmonth}}" name="month" formControlName="endmonthCtrl">
            <mat-option value="January">January</mat-option>
            <mat-option value="February">February</mat-option>
            <mat-option value="March">March</mat-option>
            <mat-option value="April">April</mat-option>
            <mat-option value="May">May</mat-option>
            <mat-option value="June">June</mat-option>
            <mat-option value="July">July</mat-option>
            <mat-option value="August">August</mat-option>
            <mat-option value="September">September</mat-option>
            <mat-option value="October">October</mat-option>
            <mat-option value="November">November</mat-option>
            <mat-option value="December">December</mat-option>
        </mat-select>
      </mat-form-field>
      
    </div> 
    <div class="col-md-2" *ngIf="admin_show == 'true'" style="padding-left: 9%;">Start Year : </div>
    <div class="col-md-2"  *ngIf="admin_show == 'true'" style="padding-left: 5%;">
        <mat-form-field id="selectLine" >
        <mat-select ngModel="{{edu_data?.startYear}}" name="year" formControlName="startyearCtrl">
        <mat-option value="{{years}}" *ngFor="let years of enrollYear">{{years}}</mat-option>
            </mat-select>
        </mat-form-field> 
    </div>
   </div>-->
    <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-3" style="text-align: center;"><label >Subject Name</label></div>
    <div class="col-md-2"  style="text-align: center;"><label>Marks Obtained</label></div>
    <div class="col-md-2"  style="text-align: center;"><label>Marks Out Of</label></div>
    <div class="col-md-1" style="text-align: center;"><label >Hours Minutes Per Week</label></div>
    <div class="col-md-1" style="text-align: center;"><label >Lectures Per Week</label></div>
    <div class="col-md-1" style="text-align: center;"><label >Months taken</label></div>
  </div>

  <div *ngIf = "show_predictive">
    <div class="row">
      <div class="col-md-1">Subject 1 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline"  style="width: 170%;" *ngIf="preEditFirst == false">
          <mat-select ngModel="{{subjectPreName}}" name="subjectname" style="width: 170%;" formControlName="subjectFirstCtrl">
            <mat-option value="{{predictive.Subject_First}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_First}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditFirst==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectFirstCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput2" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college2 of course_code2 | filter: {Course_Subject_name : filterText2}" [value]="college2"
              (click)="getCourse(college2)">
              {{college2.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 1" (click)="editDropdown()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFirstCtrl.invalid && (edu_form.controls.subjectFirstCtrl.dirty || edu_form.controls.subjectFirstCtrl.touched)}" formControlName="subjectFirstCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2"  *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstCtrl.invalid && (edu_form.controls.markFirstCtrl.dirty || edu_form.controls.markFirstCtrl.touched)}" formControlName="markFirstCtrl" placeholder="Marks Obtained" id="" (change)="hetmarksObt()"  class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstCtrl.invalid && (edu_form.controls.markFirstCtrl.dirty || edu_form.controls.markFirstCtrl.touched)}" formControlName="markFirstCtrl" placeholder="Marks Obtained" id=""  class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_First ? edu_data?.marks_out_First : edu_data?.marks_out_First =='' ? '' : ''}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_First ? edu_data?.marks_out_First : edu_data?.marks_out_First =='' ? '' : ''}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      
      <div class="col-md">
      
        <div class="row"
          *ngIf="edu_data?.Subject_First != null && edu_data?.Subject_First != '' && edu_data?.Subject_First != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName ? this.subjectPreName['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_First}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFirstCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
      
        </div>
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_First == null && preEditFirst==false">
          <input ngModel="{{ hourPreValue}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFirstCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFirst==true"><input
            ngModel="{{this.subjectName ? this.subjectName['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_First}}"
            nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="practicalhourFirstCtrl"
            placeholder="hours Minutes Per Week 1" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_First != null && edu_data?.Subject_First != '' && edu_data?.Subject_First != undefined && showcodeDropdown == false">
      
          <input ngModel="{{this.subjectPreName ? this.subjectPreName['Lectures_per_Week'] : edu_data?.lecture_hour_First}}"
            style='width: 60% !important; ' nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourFirstCtrl" placeholder="lectures Per Week" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_First == null && preEditFirst==false">
          <input ngModel="{{lecPreValue}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourFirstCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFirst==true"><input
            ngModel="{{this.subjectName ? this.subjectName['Lectures_per_Week'] : edu_data?.lecture_hour_First}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourFirstCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      </div>
        
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_First != null && edu_data?.Subject_First != '' && edu_data?.Subject_First != undefined && showcodeDropdown == false">
          <input ngModel="{{this.subjectPreName ? this.subjectPreName['Months_taken'] : edu_data?.months_taken_First}}"
            style='width: 60% !important; ' nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl" placeholder="months taken" id="" class="form-control">
        </div>
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_First == null && preEditFirst==false">
          <input ngModel="{{monthsPreTaken}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFirst==true"><input
            ngModel="{{this.subjectName ? this.subjectName['Months_taken'] :edu_data?.months_taken_First}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl" placeholder="months taken"
            id="" class="form-control"></div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-1">Subject 2 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf=" preEditSecond == false">
          <mat-select ngModel="{{subjectPreName2}}" name="subjectname" style="width: 170%;" formControlName="subjectSecondCtrl">
            <mat-option value="{{predictive.Subject_Second}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_Second}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData"style="width: 170%;" *ngIf="preEditSecond == true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectSecondCtrl" #singleSelect2>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code | filter: {Course_Subject_name : filterText}" [value]="college"
              (click)="getCourse2(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 2" (click)="editDropdown2()"></i>
        </div>
      <!-- <input  ngModel="{{edu_data?.Subject_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectSecondCtrl.invalid && (edu_form.controls.subjectSecondCtrl.dirty || edu_form.controls.subjectSecondCtrl.touched)}" formControlName="subjectSecondCtrl" placeholder="name" id="" class="form-control"> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Second}}" nbInput type="text"  formControlName="markSecondCtrl" placeholder="Marks Obtained" id="" (change)="hetmarksObt()" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Second}}" nbInput type="text"  formControlName="markSecondCtrl" placeholder="Marks Obtained" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Second ? edu_data?.marks_out_Second : edu_data?.marks_out_Second =='' ? '' : ''}}" nbInput type="text"  formControlName="markSecondOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Second ? edu_data?.marks_out_Second : edu_data?.marks_out_Second =='' ? '' : ''}}" nbInput type="text" formControlName="markSecondOutCtrl" placeholder="Out of" id="" class="form-control"></div>

      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Second != null && edu_data?.Subject_Second != '' && edu_data?.Subject_Second != undefined && showcodeDropdown == false">
          <input
            ngModel="{{this.subjectPreName2 ? this.subjectPreName2['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Second}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSecondCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Second == null && preEditSecond==false">
          <input ngModel="{{hourPreValue2}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSecondCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSecond==true"><input
            ngModel="{{this.subjectName2 ? this.subjectName2['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Second}}"
            nbInput type="text" style='width: 80% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSecondCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
      
      </div>

      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Second != null && edu_data?.Subject_Second != '' && edu_data?.Subject_Second != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName2 ? this.subjectPreName2['lecture_hour_Second'] : edu_data?.lecture_hour_Second}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourSecondCtrl" placeholder="lectures per week" id="" class="form-control">
      
      
        </div>
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Second == null && preEditSecond==false">
          <input ngModel="{{lecPreValue2}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourSecondCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSecond==true"><input
            ngModel="{{this.subjectName2 ? this.subjectName2['Lectures_per_Week'] : edu_data?.lecture_hour_Second}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourSecondCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Second != null && edu_data?.Subject_Second != '' && edu_data?.Subject_Second != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName2 ? this.subjectPreName2['months_taken_Second'] : edu_data?.months_taken_Second}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl2" placeholder="months taken" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Second == null && preEditSecond==false">
          <input ngModel="{{monthsPreTaken2}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl2" placeholder="Months taken" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSecond==true"><input
            ngModel="{{this.subjectName2 ? this.subjectName2['Months_taken'] :edu_data?.months_taken_Second}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl2" placeholder="months taken"
            id="" class="form-control"></div>
      
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 3 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf="preEditThird == false">
          <mat-select ngModel="{{subjectPreName3}}" name="subjectname" style="width: 170%;" formControlName="subjectThirdCtrl"
            #singleSelect2>
            <mat-option value="{{predictive.Subject_Third}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_Third}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditThird==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectThirdCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput3" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code3 | filter: {Course_Subject_name : filterText3}" [value]="college"
              (click)="getCourse3(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 3" (click)="editDropdown3()"></i>
        </div>
      <!-- <input  ngModel="{{edu_data?.Subject_Third}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectThirdCtrl.invalid && (edu_form.controls.subjectThirdCtrl.dirty || edu_form.controls.subjectThirdCtrl.touched)}" formControlName="subjectThirdCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2"  *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Third}}" nbInput type="text"  formControlName="markThirdCtrl" placeholder="Marks Obtained" id="" (change)="hetmarksObt()" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Third}}" nbInput type="text"  formControlName="markThirdCtrl" placeholder="Marks Obtained" id=""  class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Third ? edu_data?.marks_out_Third : edu_data?.marks_out_Third =='' ? '' : ''}}" nbInput type="text"  formControlName="markThirdOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Third ? edu_data?.marks_out_Third : edu_data?.marks_out_Third =='' ? '' : ''}}" nbInput type="text"  formControlName="markThirdOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Third != null && edu_data?.Subject_Third != '' && edu_data?.Subject_Third != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName3 ? this.subjectPreName3['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Third}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourThirdCtrl" placeholder="hours Minutes Per Week" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Third == null && preEditThird==false">
          <input ngModel="{{hourPreValue3}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourThirdCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditThird==true"><input
            ngModel="{{this.subjectName3 ? this.subjectName3['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Third}}"
            nbInput type="text" style='width: 110% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourThirdCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Third != null && edu_data?.Subject_Third != '' && edu_data?.Subject_Third != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName3 ? this.subjectPreName3['lecture_hour_Third'] : edu_data?.lecture_hour_Third}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourThirdCtrl" placeholder="lectures per week" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Third == null && preEditThird==false">
          <input ngModel="{{lecPreValue3}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourThirdCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditThird==true"><input
            ngModel="{{this.subjectName3 ? this.subjectName3['Lectures_per_Week'] : edu_data?.lecture_hour_Third}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourThirdCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>

      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Third != null && edu_data?.Subject_Third != '' && edu_data?.Subject_Third != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName3 ? this.subjectPreName3['months_taken_Third'] : edu_data?.months_taken_Third}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl3" placeholder="monts taken" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Third == null && preEditThird==false">
          <input ngModel="{{monthsPreTaken3}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl3" placeholder="Months taken" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditThird==true"><input
            ngModel="{{this.subjectName3 ? this.subjectName3['Months_taken'] :edu_data?.months_taken_Third}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl3" placeholder="months taken"
            id="" class="form-control"></div>
      
      </div>
      
    </div>
    <div class="row">
      <div class="col-md-1">Subject 4 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf="preEditFourth == false">
          <mat-select ngModel="{{subjectPreName4}}" name="subjectname" style="width: 170%;" formControlName="subjectFourthCtrl">
            <mat-option value="{{predictive.Subject_Fourth}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_Fourth}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditFourth==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectFourthCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput4" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code4 | filter: {Course_Subject_name : filterText4}" [value]="college"
              (click)="getCourse4(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 4" (click)="editDropdown4()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Fourth}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFourthCtrl.invalid && (edu_form.controls.subjectFourthCtrl.dirty || edu_form.controls.subjectFourthCtrl.touched)}" formControlName="subjectFourthCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Fourth}}" nbInput type="text" formControlName="markFourthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Fourth}}" nbInput type="text" formControlName="markFourthCtrl" placeholder="Marks Obtained" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Fourth ? edu_data?.marks_out_Fourth : edu_data?.marks_out_Fourth =='' ? '' : ''}}" nbInput type="text"  formControlName="markFourthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Fourth ? edu_data?.marks_out_Fourth : edu_data?.marks_out_Fourth =='' ? '' : ''}}" nbInput type="text"  formControlName="markFourthOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Fourth != null && edu_data?.Subject_Fourth != '' && edu_data?.Subject_Fourth != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName4 ? this.subjectPreName4['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Fourth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFourthCtrl" placeholder="hours and minutes" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Fourth == null && preEditFourth==false">
          <input ngModel="{{hourPreValue4}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFourthCtrl" placeholder="hours Minutes Per Week 4" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFourth==true"><input
            ngModel="{{this.subjectName4 ? this.subjectName4['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Fourth}}"
            nbInput type="text" style='width: 80% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFourthCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
      
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Fourth != null && edu_data?.Subject_Fourth != '' && edu_data?.Subject_Fourth != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName4 ? this.subjectPreName4['lecture_hour_Fourth'] : edu_data?.lecture_hour_Fourth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourFourthCtrl" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Fourth == null && preEditFourth==false">
          <input ngModel="{{lecPreValue4}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourFourthCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFourth==true"><input
            ngModel="{{this.subjectName4 ? this.subjectName4['Lectures_per_Week'] : edu_data?.lecture_hour_Fourth}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourFourthCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>

      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Fourth != null && edu_data?.Subject_Fourth != '' && edu_data?.Subject_Fourth != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName4 ? this.subjectPreName4['months_taken_Fourth'] : edu_data?.months_taken_Fourth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl4" placeholder="months taken" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Fourth == null && preEditFourth==false">
          <input ngModel="{{monthsPreTaken4}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl4" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFourth==true"><input
            ngModel="{{this.subjectName4 ? this.subjectName4['Months_taken'] :edu_data?.months_taken_Fourth}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl4" placeholder="months taken"
            id="" class="form-control"></div>
      
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 5 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf="preEditFifth == false">
          <mat-select ngModel="{{subjectPreName5}}" name="subjectname" style="width: 170%;" formControlName="subjectFifthCtrl">
            <mat-option value="{{predictive.Subject_Fifth}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_Fifth}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditFifth==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectFifthCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput5" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code5 | filter: {Course_Subject_name : filterText5}" [value]="college"
              (click)="getCourse5(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 5" (click)="editDropdown5()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Fifth}}" nbInput type="text"  formControlName="subjectFifthCtrl" placeholder="name" id="" class="form-control">-->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markFifthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markFifthCtrl" placeholder="Marks Obtained"  id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Fifth ? edu_data?.marks_out_Fifth : edu_data?.marks_out_Fifth =='' ? '' : ''}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Fifth ? edu_data?.marks_out_Fifth : edu_data?.marks_out_Fifth =='' ? '' : ''}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Fifth != null && edu_data?.Subject_Fifth != '' && edu_data?.Subject_Fifth != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName5 ? this.subjectPreName5['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Fifth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFifthCtrl" placeholder="hours and minutes" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Fifth == null && preEditFifth==false">
          <input ngModel="{{hourPreValue5}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourFifthCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFifth==true"><input
            ngModel="{{this.subjectName5 ? this.subjectName5['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Fifth}}"
            nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourFifthCtrl"
            placeholder="hours Minutes Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Fifth != null && edu_data?.Subject_Fifth != '' && edu_data?.Subject_Fifth != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName5 ? this.subjectPreName5['lecture_hour_Fifth'] : edu_data?.lecture_hour_Fifth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourFifthCtrl" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Fifth == null && preEditFifth==false">
          <input ngModel="{{lecPreValue5}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourFifthCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFifth==true"><input
            ngModel="{{this.subjectName5 ? this.subjectName5['Lectures_per_Week'] : edu_data?.lecture_hour_Fifth}}" nbInput
            [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="lecturehourFifthCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Fifth != null && edu_data?.Subject_Fifth != '' && edu_data?.Subject_Fifth != undefined && showcodeDropdown == false">
      
          <input
            ngModel="{{this.subjectPreName5 ? this.subjectPreName5['months_taken_Fifth'] : edu_data?.months_taken_Fifth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl5" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Fifth == null && preEditFifth==false">
          <input ngModel="{{monthsPreTaken5}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl5" placeholder="Months taken" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditFifth==true"><input
            ngModel="{{this.subjectName5 ? this.subjectName5['Months_taken'] :edu_data?.months_taken_Fifth}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl5" placeholder="months taken"
            id="" class="form-control"></div>
      
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 6 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf="preEditSixth == false">
          <mat-select ngModel="{{subjectPreName6}}" name="subjectname" style="width: 170%;" formControlName="subjectSixthCtrl">
            <mat-option value="{{predictive.Subject_Six}}" *ngFor="let predictive of predictive_data">{{predictive.Subject_Six}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditSixth==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectSixthCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput6" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code6 | filter: {Course_Subject_name : filterText6}" [value]="college"
              (click)="getCourse6(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 6" (click)="editDropdown6()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Six}}" nbInput type="text"  formControlName="subjectSixthCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markSixthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markSixthCtrl" placeholder="Marks Obtained"  id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'" ><input  ngModel="{{edu_data?.marks_out_Six ? edu_data?.marks_out_Six : edu_data?.marks_out_Six =='' ? '' : ''}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'" ><input  ngModel="{{edu_data?.marks_out_Six ? edu_data?.marks_out_Six : edu_data?.marks_out_Six =='' ? '' : ''}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Six != null && edu_data?.Subject_Six != '' && edu_data?.Subject_Six != undefined && showcodeDropdown6 == false">
      
          <input
            ngModel="{{this.subjectPreName6 ? this.subjectPreName6['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Six}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSixCtrl" placeholder="hours and minutes" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Six == null && preEditSixth==false">
          <input ngModel="{{hourPreValue6}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSixCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSixth==true"><input
            ngModel="{{this.subjectName6 ? this.subjectName6['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Six}}"
            nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourSixCtrl"
            placeholder="hours Minutes Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Six != null && edu_data?.Subject_Six != '' && edu_data?.Subject_Six != undefined && showcodeDropdown6 == false">
      
          <input ngModel="{{this.subjectPreName6 ? this.subjectPreName6['lecture_hour_Six'] : edu_data?.lecture_hour_Six}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourSixCtrl" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Six == null && preEditSixth==false">
          <input ngModel="{{lecPreValue6}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourSixCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSixth==true"><input
            ngModel="{{this.subjectName6 ? this.subjectName6['Lectures_per_Week'] : edu_data?.lecture_hour_Six}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourSixCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Six != null && edu_data?.Subject_Six != '' && edu_data?.Subject_Six != undefined && showcodeDropdown6 == false">
      
          <input ngModel="{{this.subjectPreName6 ? this.subjectPreName6['months_taken_Six'] : edu_data?.months_taken_Six}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl6" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Six == null && preEditSixth==false">
          <input ngModel="{{monthsPreTaken6}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl6" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSixth==true"><input
            ngModel="{{this.subjectName6 ? this.subjectName6['Months_taken'] :edu_data?.months_taken_Six}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl6" placeholder="months taken"
            id="" class="form-control"></div>
      
      </div> 
    </div>
    <div class="row">
      <div class="col-md-1">Subject 7 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf="preEditSeventh == false">
          <mat-select ngModel="{{subjectPreName7}}" name="subjectname" style="width: 170%;"
            formControlName="subjectSeventhCtrl">
            <mat-option value="{{predictive.Subject_Seventh}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_Seventh}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditSeventh==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectSeventhCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput7" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code7 | filter: {Course_Subject_name : filterText7}" [value]="college"
              (click)="getCourse7(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 7" (click)="editDropdown7()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Seventh}}" nbInput type="text"  formControlName="subjectSeventhCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markSeventhCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2"  *ngIf="admin_show == 'true'" ><input  ngModel="{{edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markSeventhCtrl" placeholder="Marks Obtained"  id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'" ><input  ngModel="{{edu_data?.marks_out_Seventh ? edu_data?.marks_out_Seventh : edu_data?.marks_out_Seventh =='' ? '' : ''}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'" ><input  ngModel="{{edu_data?.marks_out_Seventh ? edu_data?.marks_out_Seventh : edu_data?.marks_out_Seventh =='' ? '' : ''}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Out of" id="" class="form-control"></div>

      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Seventh != null && edu_data?.Subject_Seventh != '' && edu_data?.Subject_Seventh != undefined && showcodeDropdown7 == false">
      
          <input
            ngModel="{{this.subjectPreName7 ? this.subjectPreName7['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Seventh}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSeventhCtrl" placeholder="hours and minutes" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Seventh == null && preEditSeventh==false">
          <input ngModel="{{hourPreValue7}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourSeventhCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSeventh==true"><input
            ngModel="{{this.subjectName7 ? this.subjectName7['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Seventh}}"
            nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourSeventhCtrl"
            placeholder="hours Minutes Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Seventh != null && edu_data?.Subject_Seventh != '' && edu_data?.Subject_Seventh != undefined && showcodeDropdown7 == false">
      
          <input
            ngModel="{{this.subjectPreName7 ? this.subjectPreName7['lecture_hour_Seventh'] : edu_data?.lecture_hour_Seventh}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourSeventhCtrl" placeholder="lecture per hour" id="" class="form-control">
        </div>
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Seventh == null && preEditSeventh==false">
          <input ngModel="{{lecPreValue7}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourSeventhCtrl" placeholder="lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSeventh==true"><input
            ngModel="{{this.subjectName7 ? this.subjectName7['Lectures_per_Week'] : edu_data?.lecture_hour_Seventh}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourSeventhCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Seventh != null && edu_data?.Subject_Seventh != '' && edu_data?.Subject_Seventh != undefined && showcodeDropdown7 == false">
      
          <input
            ngModel="{{this.subjectPreName7 ? this.subjectPreName7['months_taken_Seventh'] : edu_data?.months_taken_Seventh}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl7" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Seventh == null && preEditSeventh==false">
          <input ngModel="{{monthsPreTaken7}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl7" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditSeventh==true"><input
            ngModel="{{this.subjectName7 ? this.subjectName7['Months_taken'] :edu_data?.months_taken_Seventh}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl7" placeholder="months taken"
            id="" class="form-control"></div>
      
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 8 :</div>
      <div class="col-md-2">

        <mat-form-field appearance="outline" style="width: 170%;" *ngIf="preEditEight == false">
          <mat-select ngModel="{{subjectPreName8}}" name="subjectname" style="width: 170%;" formControlName="subjectEighthCtrl">
            <mat-option value="{{predictive.Subject_Eighth}}" *ngFor="let predictive of predictive_data">
              {{predictive.Subject_Eighth}}</mat-option>
          </mat-select>
        </mat-form-field>
        
        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf="preEditEight==true">
          <mat-select placeholder="Subject" style="width: 140%;" formControlName="subjectEighthCtrl" #singleSelect>
            <mat-option>
              <ngx-mat-select-search [formControl]="filterInput8" [placeholderLabel]="'Subjects...'">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code8 | filter: {Course_Subject_name : filterText8}" [value]="college"
              (click)="getCourse8(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;"
            (click)="showContactDetails()"></i> &nbsp;&nbsp;
          <i class="fas fa-pen-alt fa-lg" title="Edit Subject 8" (click)="editDropdown8()"></i>
        </div>
      <!-- <input  ngModel="{{edu_data?.Subject_Eighth}}" nbInput type="text"  formControlName="subjectEighthCtrl" placeholder="name" id="" class="form-control"> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markEighthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2"  *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markEighthCtrl" placeholder="Marks Obtained" id="" class="form-control"></div>
      <div class="col-md-2 " *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Eighth ? edu_data?.marks_out_Eighth : edu_data?.marks_out_Eighth =='' ? '' : ''}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Eighth ? edu_data?.marks_out_Eighth : edu_data?.marks_out_Eighth =='' ? '' : ''}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Eighth != null && edu_data?.Subject_Eighth != '' && edu_data?.Subject_Eighth != undefined && showcodeDropdown8 == false">
      
          <input
            ngModel="{{this.subjectPreName8 ? this.subjectPreName8['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Eighth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourEighthCtrl" placeholder="hours and minutes" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Eighth == null && preEditEight==false">
          <input ngModel="{{hourPreValue8}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="practicalhourEighthCtrl" placeholder="hours Minutes Per Week 1" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditEight==true"><input
            ngModel="{{this.subjectName8 ? this.subjectName8['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Eighth}}"
            nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourEighthCtrl"
            placeholder="hours Minutes Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Eighth != null && edu_data?.Subject_Eighth != '' && edu_data?.Subject_Eighth != undefined && showcodeDropdown8 == false">
      
          <input
            ngModel="{{this.subjectPreName8 ? this.subjectPreName8['lecture_hour_Eighth'] : edu_data?.lecture_hour_Eighth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourEighthCtrl" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Eighth == null && preEditEight==false">
          <input ngModel="{{lecPreValue8}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="lecturehourEighthCtrl" placeholder="Lecture per week" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditEight==true"><input
            ngModel="{{this.subjectName8 ? this.subjectName8['Lectures_per_Week'] : edu_data?.lecture_hour_Eighth}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourEighthCtrl"
            placeholder="lectures Per Week" id="" class="form-control"></div>
      
      </div>
      
      <div class="col-md">
        <div class="row"
          *ngIf="edu_data?.Subject_Eighth != null && edu_data?.Subject_Eighth != '' && edu_data?.Subject_Eighth != undefined && showcodeDropdown8 == false">
      
          <input
            ngModel="{{this.subjectPreName8 ? this.subjectPreName7['months_taken_Eighth'] : edu_data?.months_taken_Eighth}}"
            nbInput type="text" style='width: 60% !important; ' [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl8" placeholder="lecture per hour" id="" class="form-control">
        </div>
      
        <div *ngIf="admin_show == 'false' && edu_data?.Subject_Eighth == null && preEditEight==false">
          <input ngModel="{{monthsPreTaken8}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"
            formControlName="monthstakenCtrl8" placeholder="Months taken" id="" class="form-control">
        </div>
        <div class="col-md" *ngIf="preEditEight==true"><input
            ngModel="{{this.subjectName8 ? this.subjectName8['Months_taken'] :edu_data?.months_taken_Eighth}}" nbInput
            type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl8" placeholder="months taken"
            id="" class="form-control"></div>
      </div>

    </div>
  </div>

  <div *ngIf = "!show_predictive">
    <div class="row">
      <div class="col-md-1">Subject 1 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_First != null && edu_data?.Subject_First != '' && edu_data?.Subject_First != undefined && showcodeDropdown == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_First" style="width: 170%;" nbInput type="text" id="" ></textarea>
          
        </div>

        <mat-form-field appearance="outline" style="width: 170%;" [formGroup]="formData" *ngIf = "showcodeDropdown == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput2"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college2 of course_code2 | filter: {Course_Subject_name : filterText2}" [value]="college2" (click)="getCourse(college2)">
              {{college2.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFirstCtrl.invalid && (edu_form.controls.subjectFirstCtrl.dirty || edu_form.controls.subjectFirstCtrl.touched)}" formControlName="subjectFirstCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2"  *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstCtrl.invalid && (edu_form.controls.markFirstCtrl.dirty || edu_form.controls.markFirstCtrl.touched)}" formControlName="markFirstCtrl" placeholder="Marks Obtained" id="" (change)="hetmarksObt()"  class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstCtrl.invalid && (edu_form.controls.markFirstCtrl.dirty || edu_form.controls.markFirstCtrl.touched)}" formControlName="markFirstCtrl" placeholder="Marks Obtained" id=""  class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_First ? edu_data?.marks_out_First : ''}}
        " nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_First ? edu_data?.marks_out_First : ''}}
        " nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md-1"><input   ngModel="{{this.subjectName ? this.subjectName['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_First}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="practicalhourFirstCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <!--  <div class="col-md-1"><i title = 'Copy' *ngIf ='edu_form.controls.practicalhourFirstCtrl.value' class="fa fa-clone" style="text-align: right; padding-left: 72% !important;" aria-hidden="true" fa-lg (click)= "copyHoursValue()"></i></div>-->

      <div class="col-md-1"><input   ngModel="{{this.subjectName ? this.subjectName['Lectures_per_Week'] : edu_data?.lecture_hour_First}}" nbInput type="text" formControlName="lecturehourFirstCtrl" [attr.disabled]="isDisabled ? '' : null" placeholder="Lectures per Week" id="" class="form-control"></div>
      <!--  <div class="col-md-1"><i title = 'Copy' *ngIf ='edu_form.controls.lecturehourFirstCtrl.value' class="fa fa-clone" style="text-align: right; padding-left: 72% !important;" aria-hidden="true" fa-lg (click)= "copyLecValue()"></i></div>-->

      <div class="col-md-1" ><input  ngModel="{{this.subjectName ? this.subjectName['Months_taken'] : edu_data?.months_taken_First}}" nbInput type="text"  formControlName="monthstakenCtrl" [attr.disabled]="isDisabled ? '' : null" placeholder="months taken" id="" class="form-control"></div>
      <!--  <div class="col-md-1"><i title = 'Copy' *ngIf ='edu_form.controls.monthstakenCtrl.value' class="fa fa-clone" style="text-align: right; padding-left: 72% !important;" aria-hidden="true" fa-lg (click)= "copyMonthValue()"></i></div>-->
    </div>
    <div class="row">
      <div class="col-md-1">Subject 2 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Second != null && edu_data?.Subject_Second != '' && edu_data?.Subject_Second != undefined && showcodeDropdown2 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Second"  style="width: 170%;" nbInput type="text" id="" ></textarea>
          
        </div>

        <mat-form-field appearance="outline" style="width: 170%;"  [formGroup]="formData" *ngIf = "showcodeDropdown2 == true">
          <mat-select placeholder="Subject" style="width: 100%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code | filter: {Course_Subject_name : filterText}" [value]="college" (click)="getCourse2(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown2()"></i>
        </div>
      <!-- <input  ngModel="{{edu_data?.Subject_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectSecondCtrl.invalid && (edu_form.controls.subjectSecondCtrl.dirty || edu_form.controls.subjectSecondCtrl.touched)}" formControlName="subjectSecondCtrl" placeholder="name" id="" class="form-control"> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Second}}" nbInput type="text"  formControlName="markSecondCtrl" placeholder="Marks Obtained" id="" (change)="hetmarksObt()" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Second}}" nbInput type="text"  formControlName="markSecondCtrl" placeholder="Marks Obtained" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Second ? edu_data?.marks_out_Second : edu_data?.marks_out_Second =='' ? '' : ''}}" nbInput type="text"  formControlName="markSecondOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Second ? edu_data?.marks_out_Second : edu_data?.marks_out_Second =='' ? '' : ''}}" nbInput type="text" formControlName="markSecondOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md-1"><input   ngModel="{{this.subjectName2 ? this.subjectName2['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Second}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourSecondCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName2 ? this.subjectName2['Lectures_per_Week'] : edu_data?.lecture_hour_Second}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourSecondCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
      <div class="col-md-1" ><input  ngModel="{{this.subjectName2 ? this.subjectName2['Months_taken'] :edu_data?.months_taken_Second}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl2" placeholder="months taken" id="" class="form-control"></div>

    </div>
    <div class="row">
      <div class="col-md-1">Subject 3 :</div>
      <div class="col-md-2">
        <div *ngIf= "edu_data?.Subject_Third != null && edu_data?.Subject_Third != '' && edu_data?.Subject_Third != undefined && showcodeDropdown3 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Third" style="width: 170%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" style="width: 170%;" [formGroup]="formData" *ngIf = "showcodeDropdown3 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput3"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code3 | filter: {Course_Subject_name : filterText3}" [value]="college" (click)="getCourse3(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown3()"></i>
        </div>
      <!-- <input  ngModel="{{edu_data?.Subject_Third}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectThirdCtrl.invalid && (edu_form.controls.subjectThirdCtrl.dirty || edu_form.controls.subjectThirdCtrl.touched)}" formControlName="subjectThirdCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2"  *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Third}}" nbInput type="text"  formControlName="markThirdCtrl" placeholder="Marks Obtained" id="" (change)="hetmarksObt()" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Third}}" nbInput type="text"  formControlName="markThirdCtrl" placeholder="Marks Obtained" id=""  class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Third ? edu_data?.marks_out_Third : edu_data?.marks_out_Third =='' ? '' : ''}}" nbInput type="text"  formControlName="markThirdOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Third ? edu_data?.marks_out_Third : edu_data?.marks_out_Third =='' ? '' : ''}}" nbInput type="text"  formControlName="markThirdOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName3 ? this.subjectName3['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Third}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourThirdCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName3 ? this.subjectName3['Lectures_per_Week'] : edu_data?.lecture_hour_Third}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourThirdCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
      <div class="col-md-1" ><input  ngModel="{{this.subjectName3 ? this.subjectName3['Months_taken'] : edu_data?.months_taken_Third}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"  formControlName="monthstakenCtrl3" placeholder="months taken" id="" class="form-control"></div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 4 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Fourth != null && edu_data?.Subject_Fourth != '' && edu_data?.Subject_Fourth != undefined && showcodeDropdown4 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Fourth"  style="width: 170%;" nbInput type="text" id="" ></textarea>
          
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData"  style="width: 170%;" *ngIf = "showcodeDropdown4 == true">
          <mat-select placeholder="Course Code" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput4"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code4 | filter: {Course_Subject_name : filterText4}" [value]="college" (click)="getCourse4(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown4()"></i>
        </div> 
        <!-- <input  ngModel="{{edu_data?.Subject_Fourth}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFourthCtrl.invalid && (edu_form.controls.subjectFourthCtrl.dirty || edu_form.controls.subjectFourthCtrl.touched)}" formControlName="subjectFourthCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Fourth}}" nbInput type="text" formControlName="markFourthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Fourth}}" nbInput type="text" formControlName="markFourthCtrl" placeholder="Marks Obtained" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Fourth ? edu_data?.marks_out_Fourth : edu_data?.marks_out_Fourth =='' ? '' : ''}}" nbInput type="text"  formControlName="markFourthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Fourth ? edu_data?.marks_out_Fourth : edu_data?.marks_out_Fourth =='' ? '' : ''}}" nbInput type="text"  formControlName="markFourthOutCtrl" placeholder="Out of" id="" class="form-control"></div> 
      <div class="col-md-1"><input   ngModel="{{this.subjectName4 ? this.subjectName4['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Fourth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourFourthCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName4 ? this.subjectName4['Lectures_per_Week'] : edu_data?.lecture_hour_Fourth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourFourthCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
      <div class="col-md-1" ><input  ngModel="{{this.subjectName4 ? this.subjectName4['Months_taken'] :edu_data?.months_taken_Fourth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl4" placeholder="months taken" id="" class="form-control"></div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 5 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Fifth != null && edu_data?.Subject_Fifth != '' && edu_data?.Subject_Fifth != undefined && showcodeDropdown5 == false">
          <textarea  disabled   [value]="edu_data?.Subject_Fifth" style="width: 170%;" nbInput type="text" id="" ></textarea>
          
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf = "showcodeDropdown5 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput5"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code5 | filter: {Course_Subject_name : filterText5}" [value]="college" (click)="getCourse5(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
    
        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown5()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Fifth}}" nbInput type="text"  formControlName="subjectFifthCtrl" placeholder="name" id="" class="form-control">-->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markFifthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markFifthCtrl" placeholder="Marks Obtained"  id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Fifth ? edu_data?.marks_out_Fifth : edu_data?.marks_out_Fifth =='' ? '' : ''}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Fifth ? edu_data?.marks_out_Fifth : edu_data?.marks_out_Fifth =='' ? '' : ''}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Out of" id="" class="form-control"></div>
      <div class="col-md-1"><input   ngModel="{{this.subjectName5 ? this.subjectName5['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Fifth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourFifthCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input   ngModel="{{this.subjectName5 ? this.subjectName5['Lectures_per_Week'] : edu_data?.lecture_hour_Fifth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourFifthCtrl" placeholder="Lectures per Week" id="" class="form-control"></div> 
      <div class="col-md-1" ><input  ngModel="{{this.subjectName5 ? this.subjectName5['Months_taken'] :edu_data?.months_taken_Fifth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl5" placeholder="months taken" id="" class="form-control"></div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 6 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Six != null && edu_data?.Subject_Six != '' && edu_data?.Subject_Six != undefined && showcodeDropdown6 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Six"  style="width: 170%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData"  style="width: 170%;" *ngIf = "showcodeDropdown6 == true">
          <mat-select placeholder="Course Code" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput6"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code6 | filter: {Course_Subject_name : filterText6}" [value]="college" (click)="getCourse6(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown6()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Six}}" nbInput type="text"  formControlName="subjectSixthCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markSixthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markSixthCtrl" placeholder="Marks Obtained"  id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'" ><input  ngModel="{{edu_data?.marks_out_Six ? edu_data?.marks_out_Six : edu_data?.marks_out_Six =='' ? '' : ''}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'" ><input  ngModel="{{edu_data?.marks_out_Six ? edu_data?.marks_out_Six : edu_data?.marks_out_Six =='' ? '' : ''}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Out of" id="" class="form-control"></div>          
      <div class="col-md-1"><input  ngModel="{{this.subjectName6 ? this.subjectName6['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Six}}" [attr.disabled]="isDisabled ? '' : null" nbInput type="text" formControlName="practicalhourSixCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName6 ? this.subjectName6['Lectures_per_Week'] : edu_data?.lecture_hour_Six}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourSixCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
      <div class="col-md-1" ><input  ngModel="{{this.subjectName6 ? this.subjectName6['Months_taken'] :edu_data?.months_taken_Six}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl6" placeholder="months taken" id="" class="form-control"></div>
    </div>
    <div class="row">
      <div class="col-md-1">Subject 7 :</div>
      <div class="col-md-2">
        <div *ngIf= "edu_data?.Subject_Seventh != null && edu_data?.Subject_Seventh != '' && edu_data?.Subject_Seventh != undefined && showcodeDropdown7 == false">
          <textarea  disabled   [value]="edu_data?.Subject_Seventh" style="width: 170%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" style="width: 170%;" [formGroup]="formData" *ngIf = "showcodeDropdown7 == true">
          <mat-select placeholder="Course Code" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput7"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code7 | filter: {Course_Subject_name : filterText7}" [value]="college" (click)="getCourse7(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown7()"></i>
        </div>
        <!-- <input  ngModel="{{edu_data?.Subject_Seventh}}" nbInput type="text"  formControlName="subjectSeventhCtrl" placeholder="name" id="" class="form-control"> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markSeventhCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2"  *ngIf="admin_show == 'true'" ><input  ngModel="{{edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markSeventhCtrl" placeholder="Marks Obtained"  id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show != 'true'" ><input  ngModel="{{edu_data?.marks_out_Seventh ? edu_data?.marks_out_Seventh : edu_data?.marks_out_Seventh =='' ? '' : ''}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'" ><input  ngModel="{{edu_data?.marks_out_Seventh ? edu_data?.marks_out_Seventh : edu_data?.marks_out_Seventh =='' ? '' : ''}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Out of" id="" class="form-control"></div>

      <div class="col-md-1"><input   ngModel="{{this.subjectName7 ? this.subjectName7['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Seventh}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourSeventhCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input   ngModel="{{this.subjectName7 ? this.subjectName7['Lectures_per_Week'] : edu_data?.lecture_hour_Seventh}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourSeventhCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName7 ? this.subjectName7['Months_taken'] :edu_data?.months_taken_Seventh}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl7" placeholder="months taken" id="" class="form-control"></div>

    </div>
    <div class="row">
      <div class="col-md-1">Subject 8 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Eighth != null && edu_data?.Subject_Eighth != '' && edu_data?.Subject_Eighth != undefined && showcodeDropdown8 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Eighth" style="width: 170%;" nbInput type="text" id="" ></textarea>
          
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 170%;" *ngIf = "showcodeDropdown8 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput8"    [placeholderLabel]="'Subjects...'" >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code8 | filter: {Course_Subject_name : filterText8}" [value]="college" (click)="getCourse8(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="editDropdown8()"></i>
        </div>
      <!-- <input  ngModel="{{edu_data?.Subject_Eighth}}" nbInput type="text"  formControlName="subjectEighthCtrl" placeholder="name" id="" class="form-control"> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
      <div class="col-md-2" *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markEighthCtrl" placeholder="Marks Obtained" (change)="hetmarksObt()" id="" class="form-control"></div>
      <div class="col-md-2"  *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markEighthCtrl" placeholder="Marks Obtained" id="" class="form-control"></div>
      <div class="col-md-2 " *ngIf="admin_show != 'true'"><input  ngModel="{{edu_data?.marks_out_Eighth ? edu_data?.marks_out_Eighth : edu_data?.marks_out_Eighth =='' ? '' : ''}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Out of" (change)="totalsMarksOut()" id="" class="form-control"></div>
      <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.marks_out_Eighth ? edu_data?.marks_out_Eighth : edu_data?.marks_out_Eighth =='' ? '' : ''}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Out of" id="" class="form-control"></div>

      <div class="col-md-1"><input   ngModel="{{this.subjectName8 ? this.subjectName8['Hours_and_Minutes_per_Week']  :edu_data?.practical_hour_Eighth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="practicalhourEighthCtrl" placeholder="Hours Minutes per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input ngModel="{{this.subjectName8 ? this.subjectName8['Lectures_per_Week'] : edu_data?.lecture_hour_Eighth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturehourEighthCtrl" placeholder="Lectures per Week" id="" class="form-control"></div>
      <div class="col-md-1"><input  ngModel="{{this.subjectName8 ? this.subjectName8['Months_taken'] :edu_data?.months_taken_Eighth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl8" placeholder="months taken" id="" class="form-control"></div>
    

    </div>
  </div>
    <br>
    <div class="row">
        <div class="col-md-2">Total obtained marks : </div>
        <div class="col-md-2">
          <input  ngModel="{{ this.totalMarks ? this.totalMarks : edu_data?.overall_marks_obt}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overmarksobtCtrl.invalid && (edu_form.controls.overmarksobtCtrl.dirty || edu_form.controls.overmarksobtCtrl.touched)}" formControlName="overmarksobtCtrl" placeholder="" id="" class="form-control"> 
        </div>
        <div class="col-md-2">Out of : </div>
        <div class="col-md-2">
          <input  ngModel="{{ this.totalMarksOut ? this.totalMarksOut : edu_data?.overall_marks_out}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overmarksoutCtrl.invalid && (edu_form.controls.overmarksoutCtrl.dirty || edu_form.controls.overmarksoutCtrl.touched)}" formControlName="overmarksoutCtrl" placeholder="" id="" class="form-control"> 
        </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-2">Percentage : </div>
      <div class="col-md-2"> <input  ngModel="{{parcen ? parcen : edu_data?.overAllYearlyGrade}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.percentageCtrl.invalid && (edu_form.controls.percentageCtrl.dirty || edu_form.controls.percentageCtrl.touched)}" formControlName="percentageCtrl" placeholder="enter percentage" id="" class="form-control"> </div>
      
    </div>
    <br>
    <div class="row">
      <div class="col-md-2">Medium of instruction : </div>
      <div class="col-md-2"> <input  [ngModel]="edu_data ? edu_data?.medium_instruction : 'English' " nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.instructionCtrl.invalid && (edu_form.controls.instructionCtrl.dirty || edu_form.controls.instructionCtrl.touched)}" formControlName="instructionCtrl" placeholder="" id="" class="form-control"> </div>
      <div class="col-md-2" *ngIf="admin_show == 'true'">Special Instruction : </div>
      <div class="col-md-2" *ngIf="admin_show == 'true'">
        <mat-form-field  appearance="outline" style="width:100% !important;  ">
          <input type="text" style="width:100% !important;" [ngModel]="specialInstruction ? specialInstruction : edu_data?.special_instruction" (change)='getSpecialInst($event)'  formControlName="specialInstrctionCtrl" placeholder="Choose Final Grade Special Instruction"  matInput [matAutocomplete]="auto2">
          <mat-autocomplete #auto2="matAutocomplete"  style="width:100% !important;  " >
            <mat-option *ngFor="let option of specialInstructionArray" [value]="option" (click)="updateSpecialInstruction(option)">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <!-- <input  ngModel="{{edu_data?.special_instruction}}" nbInput type="text" formControlName="specialInstrctionCtrl" placeholder="" id="" class="form-control"> -->
      </div>          
    </div>
    <br>
    <div class="row">
      <div class="col-md-2" *ngIf="admin_show == 'true'">Final Grade Special Instruction : </div>
      <div class="col-md-2" *ngIf="admin_show == 'true'">
        <mat-form-field  appearance="outline" style="width:100% !important;  ">
          <input type="text" style="width:100% !important;" [ngModel]="GradespecialInstruction ? GradespecialInstruction : edu_data?.final_grade_special_instruction" (change)='getGradeSpecialInst($event)'  formControlName="finalgradespecialInstrctionCtrl" placeholder="Choose Final Grade Special Instruction"  matInput [matAutocomplete]="auto2">
          <mat-autocomplete #auto2="matAutocomplete"  style="width:100% !important;  " >
            <mat-option *ngFor="let option of specialInstructionArray" [value]="option" (click)="updateGradeSpecialInstruction(option)">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
       <!-- <input  ngModel="{{edu_data?.final_grade_special_instruction}}" nbInput type="text" formControlName="finalgradespecialInstrctionCtrl" placeholder="" id="" class="form-control"> -->
      </div>
    </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
      <button nbButton hero status="primary" (click)="dismiss()">Close</button> 
      <button *ngIf="amount_paid == 'false'" nbButton status="info" (click)="saveEdu()">save</button>
  </nb-card-footer>
</nb-card>
<p-confirmDialog [style]="{width: '425px'}"></p-confirmDialog>
  `,
  providers: [ ConfirmationService]
})
export class EducationalFormComponent implements OnInit {
  FeedbackForm: FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() amount_paid: string;
  @Input() admin_show: string;
  @Input() showSpecialization: string;
  @Input() course_name_auto: string;
  @Input() college_year_auto: string;
  @Input() enrollment_year_auto: number;
  @Input() leaving_year_auto: number;

  validations_flag = false;
  feedback_message;
  showExperience = false;

  edu_form: FormGroup;
  years_array;
  courseValidation = true;
  collegeYearValidation = true;
  classValidation = true;
  monthValidation = true;
  yearValidation = true;
  attemptValidation = true;
  instructionValidation = true;
  edu_data;
  course_data;
  user: any;
  semesterValidation = true;
  totalMarks: number;
  totalMarksOut: number;
  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  monthTaken2: any;
  monthTaken1: any;
  monthTaken3: any;
  monthTaken8: any;
  monthTaken7: any;
  monthTaken6: any;
  monthTaken5: any;
  monthTaken4: any;
  parcen: number;
  newcourse_code = [];
  enrollYear = [];

  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  course_code: any;
  course_code8: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code9: any;
  course_code10: any;
  public filterText: any;
  public filterText2: any;
  filterText3: any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  autocheck = true;
  predictive_data;
  specialisation_data;
  specialisation_name: any;
  show_predictive: boolean =false;

  hourPreValue : any;
  hourPreValue2 : any;
  hourPreValue3 : any;
  hourPreValue4 : any;
  hourPreValue5 : any;
  hourPreValue6 : any;
  hourPreValue7 : any;
  hourPreValue8 : any;
  hourPreValue9 : any;
  hourPreValue10 : any;
  
  lecPreValue: any;
  lecPreValue2 : any;
  lecPreValue3 : any;
  lecPreValue4 : any;
  lecPreValue5 : any;
  lecPreValue6 : any;
  lecPreValue7 : any;
  lecPreValue8 : any;
  lecPreValue9 : any;
  lecPreValue10 : any;

  monthsPreTaken:any
  monthsPreTaken2:any
  monthsPreTaken3:any
  monthsPreTaken4:any
  monthsPreTaken5:any
  monthsPreTaken6:any
  monthsPreTaken7:any
  monthsPreTaken8:any
  monthsPreTaken9:any
  monthsPreTaken10:any

  subjectPreName : any;
  subjectPreName2 : any;
  subjectPreName3 : any;
  subjectPreName4 : any;
  subjectPreName5 : any;
  subjectPreName6 : any;
  subjectPreName7 : any;
  subjectPreName8 : any;
  subjectPreName9 : any;
  subjectPreName10 : any;

  preEditFirst: boolean = false;
  preEditSecond: boolean = false;
  preEditThird: boolean = false;
  preEditFourth: boolean = false;
  preEditFifth: boolean = false;
  preEditSixth: boolean = false;
  preEditSeventh: boolean = false;
  preEditEight: boolean = false;
  preEditNinth: boolean = false;
  preEditTenth: boolean = false;

  specialInstructionArray = ['@ As per University of Mumbai Ordinance 0.5042A/0.5043A/0.5044A',
    '& Scaled Down, Cir. No. UG/61 of 2013-2014',
    '+ Carried Forward Marks as per Ordinance of University of Mumbai',
    '* As per University of Mumbai Ordinance 0.5045a',
    '$ - Carried forward grade as per ordinance of the University of Mumbai',
    '# As per University of Mumbai, Ordinance 0.229'
  ]
  specialInstruction: any;
  specI: any;
  GradespecialInstruction: any;
  DradespecI: any;
  course_name: any;
  edu_level: any;
  college_year: any;
  enrollment_year:any;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  isDisabled = false;
  startmonth: any;
  startYear: any;

  // <div class="row">
  //       <div class="col-md-3">Percentage : </div>
  //       <div class="col-md-3"> <input  ngModel="{{edu_data?.overAllYearlyGrade}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.percentageCtrl.invalid && (edu_form.controls.percentageCtrl.dirty || edu_form.controls.percentageCtrl.touched)}" formControlName="percentageCtrl" placeholder="enter percentage" id="" class="form-control"> </div>

  //     </div>

  constructor(protected api: ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,    
    protected ref: NbDialogRef<EducationalFormComponent>) { }

  async ngOnInit() {
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: ['', Validators.required],
      collegeYearCtrl: ['', Validators.required],
      overallclassCtrl: ['', Validators.required],
      monthCtrl: ['', Validators.required],
      yearCtrl: ['', Validators.required],
      overmarksobtCtrl: ['', Validators.required],
      overmarksoutCtrl: ['', Validators.required],
      subjectFirstCtrl: [''],
      markFirstCtrl: ['', Validators.required],
      markFirstOutCtrl: ['', Validators.required],
      subjectSecondCtrl: [''],
      markSecondCtrl: [''],
      markSecondOutCtrl: [''],
      subjectThirdCtrl: [''],
      markThirdCtrl: [''],
      markThirdOutCtrl: [''],
      subjectFourthCtrl: [''],
      markFourthCtrl: [''],
      markFourthOutCtrl: [''],
      subjectFifthCtrl: [''],
      markFifthCtrl: [''],
      markFifthOutCtrl: [''],
      subjectSixthCtrl: [''],
      markSixthCtrl: [''],
      markSixthOutCtrl: [''],
      subjectSeventhCtrl: [''],
      markSeventhCtrl: [''],
      markSeventhOutCtrl: [''],
      subjectEighthCtrl: [''],
      markEighthCtrl: [''],
      markEighthOutCtrl: [''],
      instructionCtrl: ['', Validators.required],
      lecturehourFirstCtrl: [''],
      lecturehourSecondCtrl: [''],
      lecturehourThirdCtrl: [''],
      lecturehourFourthCtrl: [''],
      lecturehourFifthCtrl: [''],
      lecturehourSixCtrl: [''],
      lecturehourSeventhCtrl: [''],
      lecturehourEighthCtrl: [''],
      practicalhourFirstCtrl: [''],
      practicalhourSecondCtrl: [''],
      practicalhourThirdCtrl: [''],
      practicalhourFourthCtrl: [''],
      practicalhourFifthCtrl: [''],
      practicalhourSixCtrl: [''],
      practicalhourSeventhCtrl: [''],
      practicalhourEighthCtrl: [''],
      specialInstrctionCtrl: [''],
      totalweeksCtrl: [''],
      percentageCtrl: ['', Validators.required],
      monthstakenCtrl: [''],
      monthstakenCtrl2: [''],
      monthstakenCtrl3: [''],
      monthstakenCtrl4: [''],
      monthstakenCtrl5: [''],
      monthstakenCtrl6: [''],
      monthstakenCtrl7: [''],
      monthstakenCtrl8: [''],
      finalgradespecialInstrctionCtrl: [''],
      startyearCtrl: [''],
      endmonthCtrl: [''],

      //semesterCtrl : [ '' ,  Validators.required],
    })
    if (this.college_year_auto == 'firstYear') {
      this.college_year = 'First';
    } else if (this.college_year_auto == 'secondYear') {
      this.college_year = 'Second';
    } else if (this.college_year_auto == 'thirdYear') {
      this.college_year = 'Third';
    }

    this.api.getCouses()
      .subscribe(
        (data: any) => {
          if (data['status'] == 200) {
            this.course_data = data['data'];
            
            if (this.course_name_auto != null) {
              this.course_data.forEach(element => {
                if (element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto) {
                  this.course_name = element.CourseShortForm;
                  this.edu_level = element.type;
                }
              });
            }
          } else {

          }
          this.api.getCouseCode('year',this.course_name,this.college_year_auto, null).subscribe((data: any) => {
            if (data["status"] == 200) {
              
              this.autocheck = false;
              this.filterText = "";
              this.course_code = data["data"];
              this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText = term;
              });
              
              // this.autocheck = false;
              this.filterText2 = "";
              this.course_code2 = data["data"];
              this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText2 = term;
              });

              // this.autocheck = false;
              this.filterText3 = "";
              this.course_code3 = data["data"];
              this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText3 = term;
              });
              
              // this.autocheck = false;
              this.filterText4 = "";
              this.course_code4 = data["data"];
              this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText4 = term;
              });

              // this.autocheck = false;
              this.filterText5 = "";
              this.course_code5 = data["data"];
              this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText5 = term;
              });

              // this.autocheck = false;
              this.filterText6 = "";
              this.course_code6 = data["data"];
              this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText6 = term;
              });

              // this.autocheck = false;
              this.filterText7 = "";
              this.course_code7 = data["data"];
              this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText7 = term;
              });

              // this.autocheck = false;
              this.filterText8 = "";
              this.course_code8 = data["data"];
              this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText8 = term;
              });

              // this.autocheck = false;
              this.filterText9 = "";
              this.course_code9 = data["data"];
              this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText9 = term;
              });

              // this.autocheck = false;
              this.filterText10 = "";
              this.course_code10 = data["data"];
              this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
                this.filterText10 = term;
              });

              
      
              
            } else {
            }
          });
        });

    const now = new Date().getUTCFullYear();
    this.years_array = Array(now - (now - 55)).fill('').map((v, idx) => now - idx);
    for(let info of this.years_array){
      if(info >= this.enrollment_year_auto && info <= this.leaving_year_auto){
        this.enrollYear.push(info)
       }
    }
    
    
    
    if (this.user_id != null && this.edu_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];
              this.course_name = this.edu_data.CourseName;
              this.college_year = this.edu_data.CollegeYear;
              this.enrollment_year = this.edu_data.Year;
              if(this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined){
                this.showcodeDropdown = false
                
              }else{
                
                this.showcodeDropdown = true
              }
              if(this.edu_data.Subject_Second != null){
                this.showcodeDropdown2 = false
                
              }else{
                
                this.showcodeDropdown2 = true
              }
              if(this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined){
                this.showcodeDropdown3 = false
                
              }else{
                
                this.showcodeDropdown3 = true
              }
              if(this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined){
                this.showcodeDropdown4 = false
                
              }else{
                
                this.showcodeDropdown4 = true
              }
              if(this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined){
                this.showcodeDropdown5 = false
                
              }else{
                
                this.showcodeDropdown5 = true
              }
              if(this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined){
                this.showcodeDropdown6 = false
                
              }else{
                
                this.showcodeDropdown6 = true
              }
              if(this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined){
                this.showcodeDropdown7 = false
                
              }else{
                
                this.showcodeDropdown7 = true
              }
              if(this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined){
                this.showcodeDropdown8 = false
                
              }else{
                
                this.showcodeDropdown8 = true
              }
  
              if(this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined){
                this.showcodeDropdown9 = false
                
              }else{
                
                this.showcodeDropdown9 = true
              }
              if(this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined){
                this.showcodeDropdown10 = false
                
              }else{
                
                this.showcodeDropdown10 = true
              }
              
            } else {
              
            }
          });
    } else {
      
    }
  }
  changeValue(value:any){
    
    if(value){
      this.api.getPredictiveCourse('year',this.course_name_auto, null, value, this.college_year,null).
      subscribe((data : any)=>{
        
        if(data['status'] == 200){
          this.predictive_data = data['data'];
          
            this.predictive_data.forEach(element => {
              
              this.subjectPreName = element.Subject_First;
              this.subjectPreName2 = element.Subject_Second;
              this.subjectPreName3 = element.Subject_Third
              this.subjectPreName4 = element.Subject_Fourth;
              this.subjectPreName5 = element.Subject_Fifth;
              this.subjectPreName6 = element.Subject_Six
              this.subjectPreName7 = element.Subject_Seventh;
              this.subjectPreName8 = element.Subject_Eighth;
              this.subjectPreName9 = element.Subject_Ninth;
              this.subjectPreName10 = element.Subject_Tenth;

              this.hourPreValue = element.practical_hour_First;
              this.hourPreValue2 = element.practical_hour_Second;
              this.hourPreValue3 = element.practical_hour_Third;
              this.hourPreValue4 = element.practical_hour_Fourth;
              this.hourPreValue5 = element.practical_hour_Fifth;
              this.hourPreValue6 = element.practical_hour_Six;
              this.hourPreValue7 = element.practical_hour_Seventh;
              this.hourPreValue8 = element.practical_hour_Eighth;
              this.hourPreValue9 = element.practical_hour_Ninth;
              this.hourPreValue10 = element.practical_hour_Tenth;
              
              this.lecPreValue = element.lecture_hour_First;
              this.lecPreValue2 = element.lecture_hour_Second;
              this.lecPreValue3 = element.lecture_hour_Third;
              this.lecPreValue4 = element.lecture_hour_Fourth;
              this.lecPreValue5 = element.lecture_hour_Fifth;
              this.lecPreValue6 = element.lecture_hour_Six;
              this.lecPreValue7 = element.lecture_hour_Seventh;
              this.lecPreValue8 = element.lecture_hour_Eighth;
              this.lecPreValue9 = element.lecture_hour_Ninth;
              this.lecPreValue10 = element.lecture_hour_Tenth;


              this.monthsPreTaken = element.months_taken_First;
              this.monthsPreTaken2 = element.months_taken_Second;
              this.monthsPreTaken3 = element.months_taken_Third;
              this.monthsPreTaken4 = element.months_taken_Fourth;
              this.monthsPreTaken5 = element.months_taken_Fifth;
              this.monthsPreTaken6 = element.months_taken_Six;
              this.monthsPreTaken7 = element.months_taken_Seventh;
              this.monthsPreTaken8 = element.months_taken_Eighth;
              this.monthsPreTaken9 = element.months_taken_ninth;
              this.monthsPreTaken10 = element.months_taken_tenth;
              
                  if(value == element.Year){
                  this.show_predictive = true;
                   
              }
            });
          
        }
          else{
            this.show_predictive = false;
                    
                    this.api.getCouseCodeNew('year',this.course_name_auto, null, null,this.college_year, null)
                    .subscribe(
                      (data: any) => {
                        if (data['status'] == 200) {
                          this.autocheck = false
                          this.filterText = "";
                          this.course_code = data['data'];
                          
                          this.filterInput
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText =   term;
                
                            });
                            this.course_code2 = data['data']
                            this.filterInput2
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText2 =   term;
                
                            });
                
                            this.course_code3 = data['data']
                            this.filterInput3
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText3 =   term;
                
                            });
                            this.course_code4 = data['data']
                            this.filterInput4
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText4 =   term;
                
                            });
                            this.course_code5 = data['data']
                            this.filterInput5
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText5 =   term;
                
                            });
                            this.course_code6 = data['data']
                            this.filterInput6
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText6 =   term;
                
                            });
                            this.course_code7 = data['data']
                            this.filterInput7
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText7 =   term;
                
                            });
                            this.course_code8 = data['data']
                            this.filterInput8
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                             
                              this.filterText8 =   term;
                
                            });
                            this.course_code9 = data['data']
                            this.filterInput9
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText9 =   term;
                
                            });
                            this.course_code10 = data['data']
                            this.filterInput10
                            .valueChanges
                            .debounceTime(200)
                            .subscribe(term => {
                              
                              this.filterText10 =   term;
                
                            });
                        }         
          })
      }
    });   
  } 
}
  getCourse(value) {
    
    //this.filterText = "";
    this.subjectName = value

    var count = 0
    this.newcourse_code = [];
    this.course_code.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code.length) {
        this.course_code = this.newcourse_code
      }
    })
    // if(value.prac == 'yes'){
    
    //   this.prac_hour1 = value.Lec_per_Week
    //   this.lec_per_week1 = '-'
    // }else{
    //   this.lec_per_week1 = value.Lec_per_Week
    //   this.prac_hour1 = '-'
    
    // }
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {
    
    this.withoutCodeSub = event.target.value
    if (this.subjectName) {
      
    } else {
      
    }
  }

  getCourse2(value) {
    
    //this.filterText = "";
    this.subjectName2 = value

    var count = 0
    this.newcourse_code = [];
    this.course_code3.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code
      }
    })
    // if(value.prac == 'yes'){
    
    //   this.prac_hour2 = value.Lec_per_Week
    //   this.lec_per_week2 = '-'
    // }else{
    //   this.lec_per_week2 = value.Lec_per_Week
    //   this.prac_hour2 = '-'
    
    // }
  }

  getSubject2(event: any) {
    
    this.withoutCodeSub2 = event.target.value

  }

  getCourse3(value) {
    this.subjectName3 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code4.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code
      }
    })
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value
  }

  getCourse4(value) {

    this.subjectName4 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code5.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code
      }
    })
  }

  getSubject4(event: any) {
    
    this.withoutCodeSub4 = event.target.value

  }

  getCourse5(value) {

    this.subjectName5 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code6.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code
      }
    })
  }

  getSubject5(event: any) {
    
    this.withoutCodeSub5 = event.target.value

  }

  getCourse6(value) {

    this.subjectName6 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code7.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code
      }
    })
  }

  getSubject6(event: any) {
    
    this.withoutCodeSub6 = event.target.value

  }

  getCourse7(value) {

    this.subjectName7 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code8.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code
      }
    })
  }

  getSubject8(event: any) {
    
    this.withoutCodeSub8 = event.target.value

  }
  getCourse8(value) {

    this.subjectName8 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour8 = value.Lec_per_Week
    //   this.lec_per_week8 = '-'
    // }else{
    //   this.lec_per_week8 = value.Lec_per_Week
    //   this.prac_hour8 = '-'
    
    // }
  }
  getSubject9(event: any) {
    
    this.withoutCodeSub9 = event.target.value

  }
  getCourse10(value) {

    this.subjectName10 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour10 = value.Lec_per_Week
    //   this.lec_per_week10 = '-'
    // }else{
    //   this.lec_per_week10 = value.Lec_per_Week
    //   this.prac_hour10 = '-'
    
    // }
  }

  getSubject10(event: any) {
    
    this.withoutCodeSub10 = event.target.value

  }
  getCourse9(value) {

    this.subjectName9 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour9 = value.Lec_per_Week
    //   this.lec_per_week9 = '-'
    // }else{
    //   this.lec_per_week9 = value.Lec_per_Week
    //   this.prac_hour9 = '-'
    
    // }
  }

  getSubject7(event: any) {
    
    this.withoutCodeSub7 = event.target.value

  }

  showContactDetails(){
    this.confirmationService.confirm({
      message: 'Email - lsraheja@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;'+' Whatsapp -  +91 99306 00066'  ,
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
                
      },
      reject: () => {
        
      }
    });
  }
  
  editDropdown(){
    this.showcodeDropdown = true
    this.preEditFirst = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
  .subscribe(
    (data: any) => { 
      
      if(data['status'] == 200){
       // this.autocheck = false
        this.course_code2 = data['data']
        this.filterText2 = "";
          this.filterInput2
          .valueChanges
          .debounceTime(200)
          .subscribe(term => {
          this.filterText2 = term;
          //this.filterText2 = term;
        });
        
     
        
      }else{

      }
  });
  }

  editDropdown2(){
    
    
    this.showcodeDropdown2 = true
    this.preEditSecond = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText = "";
          this.course_code = info['data'];
          
          this.filterInput
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText = term;
          });
          
        }else{

        }
  });
  }

  editDropdown3(){
    this.showcodeDropdown3 = true
    this.preEditThird = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText3 = "";
          this.course_code3 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText3 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown4(){
    this.showcodeDropdown4 = true
    this.preEditFourth = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText4 = "";
          this.course_code4 = info['data'];
          
          this.filterInput3
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText4 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown5(){
    this.showcodeDropdown5 = true
    this.preEditFifth = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText5 = "";
          this.course_code5 = info['data'];
          
          this.filterInput5
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText5 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown6(){
    this.showcodeDropdown6 = true
    this.preEditSixth = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText6 = "";
          this.course_code6 = info['data'];
          
          this.filterInput6
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText6 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown7(){
    this.showcodeDropdown7 = true
    this.preEditSeventh = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText7 = "";
          this.course_code7 = info['data'];
          
          this.filterInput7
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText7 = term;
          });
          
        }else{

        }
  });
  }

  editDropdown8(){
    this.showcodeDropdown8 = true
    this.preEditEight = true;
    this.api.getCouseCodeEdit('year',this.course_name_auto, null, null, this.college_year, null)
    .subscribe(
      (info: any) => { 
        
        if(info['status'] == 200){
          this.autocheck = false
          this.filterText8 = "";
          this.course_code8 = info['data'];
          
          this.filterInput8
            .valueChanges
            .debounceTime(200)
            .subscribe(term => {
            //this.filterText = term;
            this.filterText8 = term;
          });
          
        }else{

        }
  });
  }



  saveEdu() {
    
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.classValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.semesterValidation = true;

    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overmarksoutCtrl.markAsDirty();
      this.edu_form.controls.overmarksobtCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.percentageCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      // if(this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value ==='' || this.edu_form.controls.semesterCtrl.value ===undefined){
      //   this.semesterValidation = false;
      // }else {
      //   this.semesterValidation = true;
      // }

      if (this.edu_form.controls.overallclassCtrl.value === null || this.edu_form.controls.overallclassCtrl.value === '' || this.edu_form.controls.overallclassCtrl.value === undefined) {
        this.classValidation = false;
      } else {
        this.classValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }
    } else {
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        overall_class: this.edu_form.controls.overallclassCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        overall_marks_obt: this.edu_form.controls.overmarksobtCtrl.value,
        overall_marks_out: this.edu_form.controls.overmarksoutCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        subjectPreFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        subjectPreSecond : this.edu_form.controls.subjectSecondCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        subjectPreThird : this.edu_form.controls.subjectThirdCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        subjectPreFourth : this.edu_form.controls.subjectFourthCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        subjectPreFifth : this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        subjectPreSixth : this.edu_form.controls.subjectSixthCtrl.value,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        subjectPreSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        subjectPreEighth : this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        // lecture_hour_First : this.edu_form.controls.lecturehourFirstCtrl.value,
        // lecture_hour_Second : this.edu_form.controls.lecturehourSecondCtrl.value,
        // lecture_hour_Third : this.edu_form.controls.lecturehourThirdCtrl.value,
        // lecture_hour_Fourth : this.edu_form.controls.lecturehourFourthCtrl.value,
        // lecture_hour_Fifth : this.edu_form.controls.lecturehourFifthCtrl.value,
        // lecture_hour_Six : this.edu_form.controls.lecturehourSixCtrl.value,
        // lecture_hour_Seventh : this.edu_form.controls.lecturehourSeventhCtrl.value,
        // lecture_hour_Eighth : this.edu_form.controls.lecturehourEighthCtrl.value,
        lecture_hour_First: this.subjectName ? this.subjectName['Lectures_per_Week'] : this.edu_form.controls.lecturehourFirstCtrl.value,
        lecture_hour_Second: this.subjectName2 ? this.subjectName2['Lectures_per_Week'] : this.edu_form.controls.lecturehourSecondCtrl.value,
        lecture_hour_Third: this.subjectName3 ? this.subjectName3['Lectures_per_Week'] : this.edu_form.controls.lecturehourThirdCtrl.value,
        lecture_hour_Fourth: this.subjectName4 ? this.subjectName4['Lectures_per_Week'] : this.edu_form.controls.lecturehourFourthCtrl.value,
        lecture_hour_Fifth: this.subjectName5 ? this.subjectName5['Lectures_per_Week'] : this.edu_form.controls.lecturehourFifthCtrl.value,
        lecture_hour_Six: this.subjectName6 ? this.subjectName6['Lectures_per_Week'] : this.edu_form.controls.lecturehourSixCtrl.value,
        lecture_hour_Seventh: this.subjectName7 ? this.subjectName7['Lectures_per_Week'] : this.edu_form.controls.lecturehourSeventhCtrl.value,
        lecture_hour_Eighth: this.subjectName8 ? this.subjectName8['Lectures_per_Week'] : this.edu_form.controls.lecturehourEighthCtrl.value,
        // practical_hour_First : this.edu_form.controls.practicalhourFirstCtrl.value,
        // practical_hour_Second : this.edu_form.controls.practicalhourSecondCtrl.value,
        // practical_hour_Third : this.edu_form.controls.practicalhourThirdCtrl.value,
        // practical_hour_Fourth : this.edu_form.controls.practicalhourFourthCtrl.value,
        // practical_hour_Fifth : this.edu_form.controls.practicalhourFifthCtrl.value,
        // practical_hour_Six : this.edu_form.controls.practicalhourSixCtrl.value,
        // practical_hour_Seventh : this.edu_form.controls.practicalhourSeventhCtrl.value,
        // practical_hour_Eighth : this.edu_form.controls.practicalhourEighthCtrl.value,

        practical_hour_First: this.subjectName ? this.subjectName['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourFirstCtrl.value,
        practical_hour_Second: this.subjectName2 ? this.subjectName2['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourSecondCtrl.value,
        practical_hour_Third: this.subjectName3 ? this.subjectName3['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourThirdCtrl.value,
        practical_hour_Fourth: this.subjectName4 ? this.subjectName4['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourFourthCtrl.value,
        practical_hour_Fifth: this.subjectName5 ? this.subjectName5['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourFifthCtrl.value,
        practical_hour_Six: this.subjectName6 ? this.subjectName6['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourSixCtrl.value,
        practical_hour_Seventh: this.subjectName7 ? this.subjectName7['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourSeventhCtrl.value,
        practical_hour_Eighth: this.subjectName8 ? this.subjectName8['Hours_and_Minutes_per_Week'] : this.edu_form.controls.practicalhourEighthCtrl.value,
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        special_instruction: this.specialInstruction ? this.specialInstruction : this.specI,
        final_grade_special_instruction: this.GradespecialInstruction ? this.GradespecialInstruction : this.DradespecI, //this.edu_form.controls.finalgradespecialInstrctionCtrl.value,
        //special_instruction : this.edu_form.controls.specialInstrctionCtrl.value,
        overAllYearlyGrade: this.edu_form.controls.percentageCtrl.value,
        // monthstakenCtrl  : this.edu_form.controls.monthstakenCtrl.value ,
        // monthstakenCtrl2  : this.edu_form.controls.monthstakenCtrl2.value,
        // monthstakenCtrl3  : this.edu_form.controls.monthstakenCtrl3.value,
        // monthstakenCtrl4  : this.edu_form.controls.monthstakenCtrl4.value,
        // monthstakenCtrl5  : this.edu_form.controls.monthstakenCtrl5.value,
        // monthstakenCtrl6  : this.edu_form.controls.monthstakenCtrl6.value,
        // monthstakenCtrl7  : this.edu_form.controls.monthstakenCtrl7.value,
        // monthstakenCtrl8  : this.edu_form.controls.monthstakenCtrl8.value,
        // monthstakenCtrl  : this.subjectName ? (this.edu_form.controls.monthstakenCtrl.value ? this.edu_form.controls.monthstakenCtrl.value : '4' ) : '',
        // monthstakenCtrl2  : this.subjectName2 ? (this.edu_form.controls.monthstakenCtrl2.value ? this.edu_form.controls.monthstakenCtrl2.value : '4') : '',
        // monthstakenCtrl3  :this.subjectName3 ? (this.edu_form.controls.monthstakenCtrl3.value ?  this.edu_form.controls.monthstakenCtrl3.value: '4') : '',
        // monthstakenCtrl4  :this.subjectName4 ? (this.edu_form.controls.monthstakenCtrl4.value ? this.edu_form.controls.monthstakenCtrl4.value : '4') : '',
        // monthstakenCtrl5  :this.subjectName5 ? (this.edu_form.controls.monthstakenCtrl5.value ? this.edu_form.controls.monthstakenCtrl5.value : '4') : '',
        // monthstakenCtrl6  :this.subjectName6 ? (this.edu_form.controls.monthstakenCtrl6.value ? this.edu_form.controls.monthstakenCtrl6.value : '4') : '',
        // monthstakenCtrl7  :this.subjectName7 ? (this.edu_form.controls.monthstakenCtrl7.value ? this.edu_form.controls.monthstakenCtrl7.value : '4') : '',
        // monthstakenCtrl8  :this.subjectName8 ? (this.edu_form.controls.monthstakenCtrl8.value ? this.edu_form.controls.monthstakenCtrl8.value : '4') : '',
        //semester: this.edu_form.controls.semesterCtrl.value,
        // monthstakenCtrl: this.subjectName ? this.subjectName['months_taken_First'] : this.edu_form.controls.monthstakenCtrl.value,
        // monthstakenCtrl2: this.subjectName2 ? this.subjectName2['months_taken_Second'] : this.edu_form.controls.monthstakenCtrl2.value,
        // monthstakenCtrl3: this.subjectName3 ? this.subjectName3['months_taken_Third'] : this.edu_form.controls.monthstakenCtrl3.value,
        // monthstakenCtrl4: this.subjectName4 ? this.subjectName4['months_taken_Fourth'] : this.edu_form.controls.monthstakenCtrl4.value,
        // monthstakenCtrl5: this.subjectName5 ? this.subjectName5['months_taken_Fifth'] : this.edu_form.controls.monthstakenCtrl5.value,
        // monthstakenCtrl6: this.subjectName6 ? this.subjectName6['months_taken_Six'] : this.edu_form.controls.monthstakenCtrl6.value,
        // monthstakenCtrl7: this.subjectName7 ? this.subjectName7['months_taken_Seventh'] : this.edu_form.controls.monthstakenCtrl7.value,
        // monthstakenCtrl8: this.subjectName8 ? this.subjectName8['months_taken_Eighth'] : this.edu_form.controls.monthstakenCtrl8.value,
        months_taken_First  : this.subjectName ? this.subjectName['Months_taken'] : this.edu_form.controls.monthstakenCtrl.value ,
        months_taken_Second  : this.subjectName2 ? this.subjectName2['Months_taken'] : this.edu_form.controls.monthstakenCtrl2.value ,
        months_taken_Third  :this.subjectName3 ? this.subjectName3['Months_taken'] :  this.edu_form.controls.monthstakenCtrl3.value,
        months_taken_Fourth :this.subjectName4 ? this.subjectName4['Months_taken'] : this.edu_form.controls.monthstakenCtrl4.value ,
        months_taken_Fifth  :this.subjectName5 ?  this.subjectName5['Months_taken'] : this.edu_form.controls.monthstakenCtrl5.value ,
        months_taken_Six  :this.subjectName6 ? this.subjectName6['Months_taken'] : this.edu_form.controls.monthstakenCtrl6.value ,
        months_taken_Seventh  :this.subjectName7 ? this.subjectName7['Months_taken'] : this.edu_form.controls.monthstakenCtrl7.value ,
        months_taken_Eighth  :this.subjectName8 ? this.subjectName8['Months_taken']  : this.edu_form.controls.monthstakenCtrl8.value ,
        // months_taken_ninth  :this.subjectName9 ? this.subjectName9['Months_taken']  : this.edu_form.controls.monthstakenCtrl9.value ,
        // months_taken_tenth   :this.subjectName10 ? this.subjectName10['Months_taken']  : this.edu_form.controls.monthstakenCtrl10.value ,
       
        practical_pre_hour_First: this.edu_form.controls.practicalhourFirstCtrl.value,
        practical_pre_hour_Second: this.edu_form.controls.practicalhourSecondCtrl.value,
        practical_pre_hour_Third: this.edu_form.controls.practicalhourThirdCtrl.value,
        practical_pre_hour_Fourth: this.edu_form.controls.practicalhourFourthCtrl.value,
        practical_pre_hour_Fifth: this.edu_form.controls.practicalhourFifthCtrl.value,
        practical_pre_hour_Six: this.edu_form.controls.practicalhourSixCtrl.value,
        practical_pre_hour_Seventh: this.edu_form.controls.practicalhourSeventhCtrl.value,
        practical_pre_hour_Eighth: this.edu_form.controls.practicalhourEighthCtrl.value,

        lecture_pre_hour_First: this.edu_form.controls.lecturehourFirstCtrl.value,
        lecture_pre_hour_Second: this.edu_form.controls.lecturehourSecondCtrl.value,
        lecture_pre_hour_Third: this.edu_form.controls.lecturehourThirdCtrl.value,
        lecture_pre_hour_Fourth: this.edu_form.controls.lecturehourFourthCtrl.value,
        lecture_pre_hour_Fifth: this.edu_form.controls.lecturehourFifthCtrl.value,
        lecture_pre_hour_Six: this.edu_form.controls.lecturehourSixCtrl.value,
        lecture_pre_hour_Seventh: this.edu_form.controls.lecturehourSeventhCtrl.value,
        lecture_pre_hour_Eighth: this.edu_form.controls.lecturehourEighthCtrl.value,

        months_pre_taken_First  : this.edu_form.controls.monthstakenCtrl.value ,
        months_pre_taken_Second  : this.edu_form.controls.monthstakenCtrl2.value ,
        months_pre_taken_Third  : this.edu_form.controls.monthstakenCtrl3.value,
        months_pre_taken_Fourth : this.edu_form.controls.monthstakenCtrl4.value ,
        months_pre_taken_Fifth  : this.edu_form.controls.monthstakenCtrl5.value ,
        months_pre_taken_Six  : this.edu_form.controls.monthstakenCtrl6.value ,
        months_pre_taken_Seventh  : this.edu_form.controls.monthstakenCtrl7.value ,
        months_pre_taken_Eighth  : this.edu_form.controls.monthstakenCtrl8.value ,
        endmonth: this.startmonth ? this.startmonth : this.edu_form.controls.endmonthCtrl.value,
        startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  dismiss() {
    this.ref.close();
  }

  hetmarksObt() {
    this.totalMarks = 0
    
    if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '' && this.edu_form.controls.markEighthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.markEighthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value))
      
    } else if (this.edu_form.controls.markSecondCtrl.value != '') {
      this.totalMarks = (Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markFirstCtrl.value))
      
    }
  }

  totalsMarksOut() {
    this.totalMarksOut = 0
    if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value) {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value) + Number(this.edu_form.controls.markFourthOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
    } else if (this.edu_form.controls.markSecondOutCtrl.value != '') {
      this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
    }

    if (this.totalMarksOut != null && this.totalMarksOut != undefined && this.totalMarks != null && this.totalMarks != undefined) {
      this.parcen = (100 * Number(this.totalMarks)) / Number(this.totalMarksOut)
      this.parcen = Number(this.parcen.toFixed(2))
      
    }
  }

  copyHoursValue() {

    if (this.edu_form.controls.practicalhourFirstCtrl.value) {
      if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue7 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue8 = this.edu_form.controls.practicalhourFirstCtrl.value;




      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue7 = this.edu_form.controls.practicalhourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue6 = this.edu_form.controls.practicalhourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue5 = this.edu_form.controls.practicalhourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue4 = this.edu_form.controls.practicalhourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue3 = this.edu_form.controls.practicalhourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
        this.hourValue = this.edu_form.controls.practicalhourFirstCtrl.value;
        this.hourValue2 = this.edu_form.controls.practicalhourFirstCtrl.value;



      }


    }
  }

  copyLecValue() {
    if (this.edu_form.controls.lecturehourFirstCtrl.value) {
      if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal8 = this.edu_form.controls.lecturehourFirstCtrl.value;
      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal7 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal6 = this.edu_form.controls.lecturehourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal5 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal4 = this.edu_form.controls.lecturehourFirstCtrl.value;


      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal3 = this.edu_form.controls.lecturehourFirstCtrl.value;

      } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
        this.lecVal1 = this.edu_form.controls.lecturehourFirstCtrl.value;
        this.lecVal2 = this.edu_form.controls.lecturehourFirstCtrl.value;


      }
    }
  }

  copyMonthValue() {
    if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken5 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken6 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken7 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken8 = this.edu_form.controls.monthstakenCtrl.value;
      }
    } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken5 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken6 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken7 = this.edu_form.controls.monthstakenCtrl.value;

      }
    } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken5 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken6 = this.edu_form.controls.monthstakenCtrl.value;

      }
    } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken5 = this.edu_form.controls.monthstakenCtrl.value;

      }
    } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4 = this.edu_form.controls.monthstakenCtrl.value;

      }
    } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3 = this.edu_form.controls.monthstakenCtrl.value;

      }
    } else if (this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value) {
      if (this.edu_form.controls.monthstakenCtrl.value) {
        this.monthTaken1 = this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2 = this.edu_form.controls.monthstakenCtrl.value;


      }
    }
  }

  updateSpecialInstruction(val) {
    this.specialInstruction = val
  }

  getSpecialInst(event: any) {

    this.specialInstruction = event.target.value

  }

  updateGradeSpecialInstruction(val) {
    
    this.GradespecialInstruction = val
  }

  getGradeSpecialInst(event: any) {

    this.GradespecialInstruction = event.target.value

  }


}